import { range } from "../utils/math/range"

export const stone = range(0, 3).map(v => '' + v)
export const sstone = range(4, 7).map(v => '' + v)
export const stick = range(10, 13).map(v => '' + v)
export const sstick = range(14, 17).map(v => '' + v)
export const hoe = range(20, 23).map(v => '' + v)
export const s_hoe = range(24, 27).map(v => '' + v)
export const k_hoe = range(30, 33).map(v => '' + v)
export const box0 = range(40, 43).map(v => '' + v)
export const box1 = range(44, 47).map(v => '' + v)
export const box2 = range(50, 53).map(v => '' + v)
export const box3 = range(54, 57).map(v => '' + v)
export const baseball = range(60, 63).map(v => '' + v)
export const milk1 = range(70, 73).map(v => '' + v)
export const milk2 = range(74, 77).map(v => '' + v)
export const milk3 = range(80, 83).map(v => '' + v)
export const ice1 = range(120, 123).map(v => '' + v)
export const ice2 = range(125, 128).map(v => '' + v)
export const ice3 = range(130, 133).map(v => '' + v)
export const ice4 = range(130, 133).map(v => '' + v)
export const ice5 = range(135, 138).map(v => '' + v)
export const burning_smoke = range(140, 143).map(v => '' + v)
export const icesword1 = range(150, 153).map(v => '' + v)
export const icesword2 = range(154, 157).map(v => '' + v)
export const beer1 = range(160, 163).map(v => '' + v)
export const beer2 = range(164, 167).map(v => '' + v)
export const boomerang = range(170, 173).map(v => '' + v)
export const armour = range(174, 177).map(v => '' + v)